import { render, staticRenderFns } from "./header-table.vue?vue&type=template&id=50290409&"
import script from "./header-table.vue?vue&type=script&lang=ts&"
export * from "./header-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports